import { render, staticRenderFns } from "./DetailsCard.vue?vue&type=template&id=7cc5c4ff"
import script from "./DetailsCard.vue?vue&type=script&lang=js"
export * from "./DetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports